
// import { PropType } from 'vue'
// import Vue, { PropType } from 'vue'
// import { mapGetters } from 'vuex'
// import toggleArrayItemMixin from "@/mixins/toggleArrayItemMixin";

// import cloneDeep from 'lodash.clonedeep'

import JDateField from '@/ui/controls/JDateField.vue'
import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'
// import JFileInput from '@/ui/controls/JFileInput.vue'

// import { formatDate } from '@/helpers/dateHelpers'
// import Plant from '@/models/Plant'
// import Harvest from '@/models/Harvest'
// import Harvest from '@/models/Harvest';
import { GardenBinInterface, id } from '@/types/models'
// import JFileContainer from '@/models/JFileContainer'
import Vue from 'vue'
import Garden from '@/models/Garden'
// import { is } from 'date-fns/locale'

// import { uploadFileToFirestore } from '@/firebase/storage'

// import { HarvestInput } from "@/types/store";

// const DEFAULT_HARVEST_ITEM: HarvestInput = {
//   date: formatDate(new Date()),
//   quantity: 1,
//   quality: undefined,
//   ripeness: undefined,
//   size: undefined,
//   traits: [],
//   note: null,
// };

interface DialogObject {
  show: boolean
  value?: string
}

// interface HarvestNumberInput {
//   quantity: number;
// }

const shapes = ['ellipse', 'rectangle']

export interface PlantInput {
  id?: string
  name: string
  abbr: string
  description?: string
  startDate: string
  endDate?: string | null
  location: {
    parent?: id
    shape: string
    x: number
    y: number
    width: number
    height?: number | undefined
  }
}

function defaultPlant(): PlantInput {
  return {
    // id: "",
    name: '',
    abbr: '',
    description: '',
    startDate: new Date().toISOString().split('T')[0],
    endDate: null,
    location: {
      parent: undefined,
      shape: shapes[0],
      x: 0,
      y: 0,
      width: 10,
      height: 10,
    },
    // type: {
    //   category: string; // plant
    //   type1: string; // ediable
    //   type2: string; // vegetable
    //   type3: string; // tomato
    //   type4: string; // indeterminate tomato
    //   type5: string; // cherry tomato
    //   type6: string; // Sungold
    // }
  }
}

// const getKeyValue = <T extends object, U extends keyof T>(key: U) => (obj: T) => obj[key];

export default Vue.extend({
  components: {
    JDateField,
    PlantAvatar,
    // JFileInput,
  },
  // mixins: [toggleArrayItemMixin],
  props: {
    // value: [String as PropType<id>, Array as PropType<id[]>],
    // value: Array as PropType<id[]>,
    gardenId: String,
    // plantId: String,
    // fullscreen: Boolean,
  },
  data: () => ({
    plant: defaultPlant(),
    // input: cloneDeep(DEFAULT_HARVEST_ITEM) as HarvestInput,
    // images: [] as Array<JFileContainer>,

    readonly: false,
    submitting: false,
    // additionalTraits: [] as string[],

    // additionalTraitDialog: {
    //   show: false,
    //   value: undefined,
    // } as DialogObject,

    // showAllTraits: false,
  }),
  computed: {
    // ...mapGetters([
    //   'plants'
    // ]),
    // plants(): Array<Plant> {
    //   return this.$store.getters["gardens/plants/inGarden"](this.gardenId);
    // },
    fullscreen(): boolean {
      return this.$vuetify.breakpoint.xsOnly
    },
    garden(): Garden {
      return this.$store.getters['gardens/find'](this.gardenId)
    },
    gardenBins(): GardenBinInterface[] {
      return this.garden.map.bins // garden.map.bins;
    },
    hasAvatar(): boolean {
      return false
    },
    shapes(): string[] {
      return shapes
    },
    rules(): Record<
      string,
      (...args: any[]) => (value: string) => string | boolean
    > {
      return {
        required: () => (value: string | number) =>
          (value !== undefined &&
            (typeof value === 'string'
              ? value.length > 0
              : typeof value === 'number'
              ? true
              : false)) ||
          'Required.',
        isNumber: () => (value: string) => {
          const num = Number(value)
          if (isNaN(num)) return 'Invalid number.'
          return true
        },
        isDateOnly:
          (allowUndefined = false) =>
          (value: string) => {
            if (allowUndefined && !value) return true
            if (!value || value.length !== 10 || value.split('-').length !== 3)
              return 'Invalid date.'
            const [year, month, date] = value.split('-').map((v) => parseInt(v))
            if (isNaN(year) || isNaN(month) || isNaN(date))
              return 'Invalid date.'
            if (month < 1 || month > 12) return 'Invalid month.'
            if (date < 1 || date > 31) return 'Invalid day.'
            if (
              new Date(Date.UTC(year, month - 1, date))
                .toISOString()
                .split('T')[0] !== value
            )
              return 'Invalid date.'
            return true
          },
        isNumberInBin: (axis: 'x' | 'y') => (value: string) => {
          const num = Number(value)
          if (isNaN(num)) return 'Invalid number.'
          // TODO: check if number is in bin
          return true
        },
        isBinId: () => (value: string) => {
          const bin = this.gardenBins.find((b) => b.id === value)
          if (!bin) return 'Invalid bin.'
          return true
        },
        isShape: () => (value: string) => {
          const shape = this.shapes.find((s) => s === value)
          if (!shape) return 'Invalid shape.'
          return true
        },
      }
    },
    // plant(): Plant {
    //   return this.$store.getters["gardens/plants/find"](this.plantId);
    // },
    // plantId(): id {
    //   return Array.isArray(this.value) ? this.value[0] : this.value
    // },
    // allTraitItems(): string[] {
    //   return [...new Set([...this.traitItems, ...this.additionalTraits])];
    // },
    // traitItems(): string[] {
    //   return this.plants
    //     .map((p: Plant) => p.harvests.map((h: Harvest) => h.traits || []))
    //     .flat(2);
    //   // console.log(items.flat(2))
    //   // // console.log([...new Set(...this.plants.map(p => (p.harvests || []).map(h => (h.traits || []))))])
    //   // return [...new Set(...this.plants.map(p => (p.harvests || []).map(h => (h.traits || []))))]
    // },
    // plant() {
    //   return this.$store.getters.plant(this.plantId)
    // },
  },
  methods: {
    toNumber(val?: string | number, defaultValue = 0): number {
      return Number(val ?? defaultValue)
    },
    // inc(propName: string): void {
    // inc(key: keyof HarvestInput) {
    //   this.input[key]++;
    // },
    // dec(key: keyof HarvestInput): void {
    //   if (Number(this.input[key]) > 1) this.input[key]--;
    // },
    // onPlantChange(e: id): void {
    //   this.$emit("input", [e]);
    // },
    // onFileChange(v: Array<JFileContainer>) {
    //   this.images = v;
    // },
    // addAdditionalTrait(newTrait: string, autoselect = true): void {
    //   this.additionalTraits.push(newTrait);
    //   this.additionalTraitDialog.value = undefined;
    //   this.additionalTraitDialog.show = false;
    //   if (autoselect) this.toggleArrayItem(newTrait, this.input.traits);
    // },

    isInvalid() {
      // const isIntegerGreaterThan = (val: number, min = 0) =>
      //   Number.isInteger(val) && val > min
      // const isNumberBetween = (val?: number, min = 1, max = 5) =>
      //   typeof val === 'number' && val >= min && val <= max

      if (!this.gardenId) return 'select garden'
      // if (!this.input.date) return "select a date";
      // if (!isIntegerGreaterThan(this.input.quantity, 0))
      //   return "invalid quantity";
      // if (!isNumberBetween(this.input.quality, 0, 5)) return "invalid quality";
      // if (!isNumberBetween(this.input.ripeness)) return "invalid ripeness";
      // if (!isNumberBetween(this.input.size)) return "invalid size";
    },
    onLocationChange(field: 'x' | 'y' | 'width' | 'height') {
      return (value: string) => {
        this.plant.location[field] = this.toNumber(value)
      }
    },
    resetInput(): void {
      // this.input = cloneDeep(defaultObj);
      // this.images = [];
      this.plant = defaultPlant()
    },
    submitAndClose(): void {
      this.submit(true)
      // .then(res => this.$emit('close'))
    },
    submitAndClear(): void {
      this.submit().then(() => this.resetInput())
    },
    submit(closeOnSuccess = false): Promise<void> {
      const form = this.$refs.form as any

      if (!form.validate()) {
        this.$store.dispatch('snackbars/error', 'Invalid form')
        return Promise.reject('Invalid form')
      }

      // validate form
      const isInvalid = this.isInvalid()
      if (isInvalid) {
        this.$store.dispatch('snackbars/error', isInvalid)
        throw Error(isInvalid)
      }

      this.submitting = true
      // return new Promise((resolve, reject) => {
      return this.$store
        .dispatch('gardens/plants/add', {
          gardenId: this.gardenId,
          plant: this.plant,
        })
        .then((res) => {
          if (closeOnSuccess) this.$emit('close')
          return res
        })
        .then(() =>
          this.$store.dispatch(
            'snackbars/add',
            `Added plant to ${this.garden.name}`
          )
        )
        .then(() => {
          this.plant = defaultPlant()
        })
        .catch((err) => {
          this.$store.dispatch('snackbars/error', err.message)
          return Promise.reject(err)
        })
        .finally(() => (this.submitting = false))
      // });
    },
  },
})
